import React, { useEffect, useState } from 'react'
import ListGroup from '../../userPages/partials/ListGroup'
import UserHero from '../../userPages/partials/UserHero'
import { FaFrownOpen } from "react-icons/fa";

export default function Confirm() {
    let [data,setData] = useState([])



async function deleteData(_id) {
    
   if(window.confirm("Are You Sure to Delete that Item :")){
    let response = await fetch(`/api/confirm/`+ _id,{
        method:"DELETE",
        headers:{
            "content-type" : "application/json"
        },
        body: JSON.stringify({...data})
    })
    
    response = await response.json()
    if(response.length){
        setData(response)
    }
   }
}



async function getApiData() {
    let response = await fetch( "/api/confirm" , {
           method :"GET",
           headers:{
            "content-type":"application/json",
            "authorization":localStorage.getItem("token")
                  }
    })

    response = await response.json()
    
    if(response.result = "Done"){
        setData(response.data)
        
      
    }
    else
setData([])
    
}



useEffect(()=>{
    getApiData()
} ,[data.length])
  return (
    <>
    <UserHero/>
       <div className="container">
       
                <div className="row my-3">
                 
                   <ListGroup/>
                  
                  <div className="col-md-8">
         <h1 className=' testimonials-h1 text-light text-center p-2' style={{background:"#"}}>Confirm Table</h1>
         <div className="table-responsive">
             {
                data.length?

                <table className='table table-bordered responsive'>
                <thead>
                    <tr>
                           <th>id</th>
                         <th>booking status</th>
                        <th>payment mode</th>
                         <th>payment status</th>
                         <th>sub total</th>
                         <th>gst(%)</th>
                         <th>total</th>
                        <th>rppid</th>
                        <th>date</th>
                       
                    </tr>
                </thead>
                <tbody>
                {
                        data.map((item,index)=>{
                            return <tr key={index}>
                                <td>{item._id}</td>
                                <td>{item.bookingStatus}</td>
                                <td>{item.paymentMode}</td>
                                <td>{item.paymentStatus}</td>
                                <td>{item.subtotal}</td>
                                <td>{item.gst}</td>
                                <td>{item.total}</td>
                                <td>{item.rppid}</td>
                                <td>{new Date(item.date).toLocaleString()}</td>

                                <td>
                                <button className="btn btn-danger" onClick={() => deleteData(item._id)}>
                           <img src="/images/bin.png" loading="lazy" height={25} width={25} alt="" />
                            </button>
                                </td>

                            </tr>
                        })
                    }
                </tbody>
              </table>
              :
              <div className="not-testinomonil">
                <h3>Sorry! <FaFrownOpen />  Confirm Booking Record Not Found!!</h3>
                
              </div>
             }
            
                  </div>
              </div>
              </div>
       </div>
    </>
  )
}

